<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <i class="md-icon fas fa-desktop"/>
                                </div>
                                <h4 class="title">Liste des types d'intervention</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <md-table v-model="types" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="#"><span>{{ item.id }}</span></md-table-cell>
                                <md-table-cell md-label="Nom"><span>{{ item.name }}</span></md-table-cell>
                                <md-table-cell md-label="Modèle"><span>{{ item.intervention_report_type_id }}</span></md-table-cell>
                                <md-table-cell md-label="Version"><span>{{ item.version }}</span></md-table-cell>
                                <md-table-cell md-label="Dispositifs liés">
                                    <div v-for="(device_type, index) in getDeviceList(item)" :key="index">{{ '(' + device_type.id + ') ' +  device_type.name }}</div>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InterventionType",
    data() {
        return {
            types: [],
        }
    },
    methods: {
        async getInterventionReportTypes() {
            const response = await this.$store.dispatch('interventionTypes/getInterventionTypes')
            this.types = response.data
        },
        goToRoute(route, param = null, id = null) {
            this.$router.push({ name: route, params: { [param]: id } })
        },
        getDeviceList(item) {
            let list = []
            this.recurse(list, item)
            return list
        },
        recurse(list, item) {
            for (let j = 0; j < item.device_types.length; j++) {
                list.push(item.device_types[j])
            }
            for (let i = 0; i < item.groups.length; i++) {
                this.recurse(list, item.groups[i])
            }
        }
    },
    mounted() {
        this.getInterventionReportTypes()
    }
}
</script>

<style scoped>

</style>
